import { css } from '@linaria/core'

export const cssMainErrorPageContainer = css`
  min-width: 100vw;
  display: flex;
  /* justify-content: space-between; */
  flex-direction: column;
  background: url('./login-bg.svg') left center no-repeat;
  background-size: cover;
  height: 100vh;
  overflow-y: auto;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }
`

export const cssMainErrorPage404Container = css`
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
`
